import { toaster } from 'evergreen-ui';
import asyncFetch from '../utils/asyncFetch';

const mobileRequests = {};

mobileRequests.addRequest = async ({ phoneNumber, token }) => {
  try {
    return await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/mobile/add`, {
      method: 'POST',
      body: {
        phoneNumber,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.log(error, error.data);
    if (error?.data?.data?.code === 'PHONE_NUMBER_ALREADY_IN_USE') {
      toaster.danger('Phone number already in use');
    } else {
      toaster.danger('Something went wrong');
    }
  }
};

mobileRequests.verifyRequest = async ({ OTP, token }) => {
  try {
    await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/mobile/verify`, {
      method: 'POST',
      body: {
        OTP,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    const updatedUser = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/users/me`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    return updatedUser;
  } catch (error) {
    return null;
  }
};

export default mobileRequests;
